import React, { useEffect, useState } from 'react';
import BasicInput from '../Basic/BasicInput';

function Duration({
    duration, countIndex, changeFieldsMultiple, type = undefined, 
}) {
    const [stateDuration, setStateDuration] = useState(duration);

    useEffect(() => {
        setStateDuration(duration);
    }, [duration]);

    const changeDuration = () => {
        duration !== stateDuration && changeFieldsMultiple([
            {
                index: countIndex,
                field: 'duration',
                value: stateDuration,
            },
        ]);
    };
    
    return (
        <BasicInput 
            name='duration'
            value={stateDuration}
            onChange={e => setStateDuration(e.target.value)}
            floatingLabelStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '9px' }}
            type={type || 'string'}
            onBlur={changeDuration}
        />
    );
}

export default React.memo(Duration);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/Durations.jsx